module.exports = require("@material-ui/core/Zoom");